import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class FormListPropsBuilder extends PropsBuilder<'editableList'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { general: { visualEffect } } });
    return this;
  };

  constructor(props: PartialPropsOf<'editableList'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
